/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './external_api_common';
import '../../fees/external/payment_price';
import '../../riskevaluation/external/risk_evaluation';
import '../../connect/v2/resources/address';
import '../../connect/v2/resources/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "ReadOnlyExcept": {
                "fields": {
                  "subfields": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "Payment": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 26,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 32,
                    "rule": "optional"
                  },
                  "appFeeMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "appFeeAllocations": {
                    "type": ".squareup.connect.v2.AppFeeAllocation",
                    "id": 73,
                    "rule": "repeated"
                  },
                  "approvedMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 35,
                    "rule": "optional"
                  },
                  "paymentFeesSpec": {
                    "type": ".squareup.connect.v2.PaymentFeesSpec",
                    "id": 33,
                    "rule": "optional"
                  },
                  "processingFee": {
                    "type": ".squareup.connect.v2.ProcessingFee",
                    "id": 25,
                    "rule": "repeated"
                  },
                  "appProcessingFee": {
                    "type": ".squareup.connect.v2.AppProcessingFee",
                    "id": 36,
                    "rule": "repeated"
                  },
                  "refundedMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "delayDuration": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "delayAction": {
                    "type": "string",
                    "id": 43,
                    "rule": "optional"
                  },
                  "delayedUntil": {
                    "type": "string",
                    "id": 44,
                    "rule": "optional"
                  },
                  "sourceType": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cardDetails": {
                    "type": ".squareup.connect.v2.CardPaymentDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "balanceDetails": {
                    "type": ".squareup.connect.v2.BalancePaymentDetails",
                    "id": 14,
                    "rule": "optional"
                  },
                  "cashDetails": {
                    "type": ".squareup.connect.v2.CashPaymentDetails",
                    "id": 39,
                    "rule": "optional"
                  },
                  "bankAccountDetails": {
                    "type": ".squareup.connect.v2.BankAccountPaymentDetails",
                    "id": 49,
                    "rule": "optional"
                  },
                  "electronicMoneyDetails": {
                    "type": ".squareup.connect.v2.ElectronicMoneyDetails",
                    "id": 65,
                    "rule": "optional"
                  },
                  "externalDetails": {
                    "type": ".squareup.connect.v2.ExternalPaymentDetails",
                    "id": 40,
                    "rule": "optional"
                  },
                  "walletDetails": {
                    "type": ".squareup.connect.v2.DigitalWalletDetails",
                    "id": 48,
                    "rule": "optional"
                  },
                  "buyNowPayLaterDetails": {
                    "type": ".squareup.connect.v2.BuyNowPayLaterDetails",
                    "id": 54,
                    "rule": "optional"
                  },
                  "squareAccountDetails": {
                    "type": ".squareup.connect.v2.SquareAccountDetails",
                    "id": 56,
                    "rule": "optional"
                  },
                  "healthcareDetails": {
                    "type": ".squareup.connect.v2.HealthcareDetails",
                    "id": 60,
                    "rule": "optional"
                  },
                  "trustedPartnerDetails": {
                    "type": ".squareup.connect.v2.TrustedPartnerDetails",
                    "id": 69,
                    "rule": "optional"
                  },
                  "storedValueDetails": {
                    "type": ".squareup.connect.v2.StoredValuePaymentDetails",
                    "id": 74,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 17,
                    "rule": "optional"
                  },
                  "customerId": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "employeeId": {
                    "type": "string",
                    "id": 37,
                    "rule": "optional"
                  },
                  "teamMemberId": {
                    "type": "string",
                    "id": 52,
                    "rule": "optional"
                  },
                  "refundIds": {
                    "type": "string",
                    "id": 18,
                    "rule": "repeated"
                  },
                  "disputeIds": {
                    "type": "string",
                    "id": 19,
                    "rule": "repeated"
                  },
                  "riskEvaluation": {
                    "type": ".squareup.connect.v2.RiskEvaluation",
                    "id": 21,
                    "rule": "optional"
                  },
                  "terminalCheckoutId": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "accountId": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "buyerEmailAddress": {
                    "type": "string",
                    "id": 27,
                    "rule": "optional"
                  },
                  "billingAddress": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 28,
                    "rule": "optional"
                  },
                  "shippingAddress": {
                    "type": ".squareup.connect.v2.resources.Address",
                    "id": 29,
                    "rule": "optional"
                  },
                  "note": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "statementDescriptionIdentifier": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "capabilities": {
                    "type": "string",
                    "id": 38,
                    "rule": "repeated"
                  },
                  "disabledCapabilities": {
                    "type": ".squareup.connect.v2.CapabilitiesList",
                    "id": 58,
                    "rule": "optional"
                  },
                  "receiptNumber": {
                    "type": "string",
                    "id": 41,
                    "rule": "optional"
                  },
                  "receiptUrl": {
                    "type": "string",
                    "id": 42,
                    "rule": "optional"
                  },
                  "refundPolicy": {
                    "type": ".squareup.connect.v2.RefundPolicy",
                    "id": 45,
                    "rule": "optional"
                  },
                  "recurringDetails": {
                    "type": ".squareup.connect.v2.RecurringPaymentDetails",
                    "id": 50,
                    "rule": "optional"
                  },
                  "issuerInstallmentDetails": {
                    "type": ".squareup.connect.v2.IssuerInstallmentDetails",
                    "id": 63,
                    "rule": "optional"
                  },
                  "deviceDetails": {
                    "type": ".squareup.connect.v2.DeviceDetails",
                    "id": 51,
                    "rule": "optional"
                  },
                  "applicationDetails": {
                    "type": ".squareup.connect.v2.ApplicationDetails",
                    "id": 53,
                    "rule": "optional"
                  },
                  "foreignExchange": {
                    "type": ".squareup.connect.v2.ForeignExchange",
                    "id": 55,
                    "rule": "optional"
                  },
                  "buyerCurrencyExchange": {
                    "type": ".squareup.connect.v2.CurrencyExchange",
                    "id": 72,
                    "rule": "optional"
                  },
                  "proposalId": {
                    "type": "string",
                    "id": 59,
                    "rule": "optional"
                  },
                  "isOfflinePayment": {
                    "type": "bool",
                    "id": 64,
                    "rule": "optional"
                  },
                  "offlinePaymentDetails": {
                    "type": ".squareup.connect.v2.OfflinePaymentDetails",
                    "id": 67,
                    "rule": "optional"
                  },
                  "isTestPayment": {
                    "type": "bool",
                    "id": 62,
                    "rule": "optional"
                  },
                  "superPosMetadata": {
                    "type": ".squareup.connect.v2.SuperPosMetadata",
                    "id": 68,
                    "rule": "optional"
                  },
                  "authenticationResult": {
                    "type": ".squareup.connect.v2.AuthenticationResult",
                    "id": 70,
                    "rule": "optional"
                  },
                  "buyerDetails": {
                    "type": ".squareup.connect.v2.BuyerDetails",
                    "id": 75,
                    "rule": "optional"
                  },
                  "versionToken": {
                    "type": "string",
                    "id": 1000,
                    "rule": "optional"
                  },
                  "version": {
                    "type": "int64",
                    "id": 1010,
                    "rule": "optional"
                  }
                }
              },
              "ForeignExchange": {
                "fields": {
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "exchangeRate": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CurrencyExchange": {
                "fields": {
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "exchangeRate": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "CardPaymentDetails": {
                "fields": {
                  "status": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "card": {
                    "type": ".squareup.connect.v2.resources.Card",
                    "id": 2,
                    "rule": "optional"
                  },
                  "entryMethod": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cvvStatus": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "avsStatus": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "authResultCode": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "applicationIdentifier": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "applicationName": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "applicationCryptogram": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "verificationMethod": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "verificationResults": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "statementDescription": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  },
                  "deviceDetails": {
                    "type": ".squareup.connect.v2.DeviceDetails",
                    "id": 14,
                    "rule": "optional"
                  },
                  "felicaDetails": {
                    "type": ".squareup.connect.v2.FelicaDetails",
                    "id": 23,
                    "rule": "optional"
                  },
                  "panFideliusToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "cardPaymentTimeline": {
                    "type": ".squareup.connect.v2.CardPaymentTimeline",
                    "id": 16,
                    "rule": "optional"
                  },
                  "refundRequiresCardPresence": {
                    "type": "bool",
                    "id": 17,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": "string",
                    "id": 18,
                    "rule": "optional"
                  },
                  "signatureBehavior": {
                    "type": "string",
                    "id": 19,
                    "rule": "optional"
                  },
                  "applicationTransactionCounter": {
                    "type": "string",
                    "id": 20,
                    "rule": "optional"
                  },
                  "remainingBalanceAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 21,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "cardSurchargeMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 22,
                    "rule": "optional"
                  },
                  "emvDetails": {
                    "type": ".squareup.connect.v2.EmvDetails",
                    "id": 24,
                    "rule": "optional"
                  },
                  "authorizationParameters": {
                    "type": ".squareup.connect.v2.AuthorizationParameters",
                    "id": 25,
                    "rule": "optional"
                  },
                  "proposedCardSurchargeDetails": {
                    "type": ".squareup.connect.v2.CardSurchargeDetails",
                    "id": 26,
                    "rule": "optional"
                  },
                  "appliedCardSurchargeDetails": {
                    "type": ".squareup.connect.v2.CardSurchargeDetails",
                    "id": 27,
                    "rule": "optional"
                  }
                }
              },
              "EmvDetails": {
                "fields": {
                  "ptagIssuerPinRequest": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "authorizationResponseCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "BalancePaymentDetails": {
                "fields": {
                  "accountId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "CashPaymentDetails": {
                "fields": {
                  "buyerSuppliedMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "changeBackMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cashDrawerDetails": {
                    "type": ".squareup.connect.v2.CashDrawerDetails",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ExternalPaymentDetails": {
                "fields": {
                  "type": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "source": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sourceId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "sourceFeeMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "RecurringPaymentDetails": {
                "fields": {
                  "seriesPosition": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "previousPaymentId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "IssuerInstallmentDetails": {
                "fields": {
                  "type": {
                    "type": ".squareup.connect.v2.IssuerInstallmentDetails.IssuerInstallmentType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "installmentCount": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "IssuerInstallmentType": {
                    "values": {
                      "NO_INSTALLMENTS": 0,
                      "FIXED": 1,
                      "REVOLVING": 2
                    }
                  }
                }
              },
              "BankAccountPaymentDetails": {
                "fields": {
                  "bankName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transferType": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountOwnershipType": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "fingerprint": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "country": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "statementDescription": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "achDetails": {
                    "type": ".squareup.connect.v2.ACHDetails",
                    "id": 7,
                    "rule": "optional"
                  },
                  "openBankingDetails": {
                    "type": ".squareup.connect.v2.OpenBankingDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "eftDetails": {
                    "type": ".squareup.connect.v2.EFTDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "ACHDetails": {
                "fields": {
                  "routingNumber": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "OpenBankingDetails": {
                "fields": {
                  "transactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "resourceToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buyerAuthorizedAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "EFTDetails": {
                "fields": {
                  "branch": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "institution": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "accountNumberSuffix": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "accountType": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DigitalWalletDetails": {
                "fields": {
                  "status": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "brand": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "statementDescription": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "deviceDetails": {
                    "type": ".squareup.connect.v2.DeviceDetails",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cashAppDetails": {
                    "type": ".squareup.connect.v2.CashAppDetails",
                    "id": 5,
                    "rule": "optional"
                  },
                  "paypayDetails": {
                    "type": ".squareup.connect.v2.PaypayDetails",
                    "id": 8,
                    "rule": "optional"
                  },
                  "lightningDetails": {
                    "type": ".squareup.connect.v2.LightningDetails",
                    "id": 10,
                    "rule": "optional"
                  },
                  "multiBrandDetails": {
                    "type": ".squareup.connect.v2.MultiBrandDetails",
                    "id": 11,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "entryMethod": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "CashAppDetails": {
                "fields": {
                  "buyerFullName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "buyerCountryCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "buyerCashtag": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "PaypayDetails": {
                "fields": {
                  "transactionId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "LightningDetails": {
                "fields": {
                  "paymentUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "expiresAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountMilliSats": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "MultiBrandDetails": {
                "fields": {
                  "qrCodeAuthUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "availablePaymentMethods": {
                    "type": ".squareup.connect.v2.MultiBrandDetails.MultiBrandPaymentMethod",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "expiresAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "localizedStatus": {
                    "type": ".squareup.connect.v2.LocalizedStatus",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "MultiBrandPaymentMethod": {
                    "values": {
                      "DEFAULT_PAYMENT_METHOD_DO_NOT_USE": 0,
                      "PAYPAY": 1,
                      "AU_PAY": 2,
                      "MERPAY": 3,
                      "RAKUTEN_PAY": 4,
                      "D_BARAI": 5,
                      "ALIPAY": 6,
                      "WECHAT_PAY": 7
                    }
                  }
                }
              },
              "LocalizedStatus": {
                "fields": {
                  "success": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "DeviceDetails": {
                "fields": {
                  "deviceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deviceInstallationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "deviceName": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deviceCredential": {
                    "type": ".squareup.connect.v2.DeviceCredential",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "DeviceCredential": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FelicaDetails": {
                "fields": {
                  "terminalId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "felicaMaskedCardNumber": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "felicaBrand": {
                    "type": ".squareup.connect.v2.FelicaDetails.FelicaBrand",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "FelicaBrand": {
                    "values": {
                      "UNKNOWN": 0,
                      "FELICA_ID": 1,
                      "FELICA_TRANSPORTATION": 2,
                      "FELICA_QP": 3
                    }
                  }
                }
              },
              "ApplicationDetails": {
                "fields": {
                  "squareProduct": {
                    "type": ".squareup.connect.v2.ApplicationDetails.ExternalSquareProduct",
                    "id": 2,
                    "rule": "optional"
                  },
                  "applicationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ExternalSquareProduct": {
                    "values": {
                      "APPOINTMENTS": 1,
                      "ECOMMERCE_API": 2,
                      "INVOICES": 3,
                      "ONLINE_STORE": 4,
                      "OTHER": 5,
                      "RESTAURANTS": 6,
                      "RETAIL": 7,
                      "SQUARE_POS": 8,
                      "TERMINAL_API": 9,
                      "VIRTUAL_TERMINAL": 10
                    }
                  }
                }
              },
              "BuyNowPayLaterDetails": {
                "fields": {
                  "brand": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "afterpayDetails": {
                    "type": ".squareup.connect.v2.AfterpayDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clearpayDetails": {
                    "type": ".squareup.connect.v2.ClearpayDetails",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "AfterpayDetails": {
                "fields": {
                  "emailAddress": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ClearpayDetails": {
                "fields": {
                  "emailAddress": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SquareAccountDetails": {
                "fields": {
                  "paymentSourceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "CardPaymentTimeline": {
                "fields": {
                  "authorizedAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "capturedAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "voidedAt": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ProcessingFee": {
                "fields": {
                  "effectiveAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AppProcessingFee": {
                "fields": {
                  "priceSelector": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "type": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "partyAccountId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "effectiveAt": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "RefundPolicy": {
                "fields": {
                  "defaultRefundSplit": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CapabilitiesList": {
                "fields": {
                  "capabilities": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "HealthcareDetails": {
                "fields": {
                  "prescriptionAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "visionAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dentalAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "otherHealthcareAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ElectronicMoneyDetails": {
                "fields": {
                  "felicaDetails": {
                    "type": ".squareup.connect.v2.FelicaDetails",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OfflinePaymentDetails": {
                "fields": {
                  "clientCreatedAt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "uploadedAt": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "AuthorizationParameters": {
                "fields": {
                  "createAuthorizationType": {
                    "type": ".squareup.connect.v2.AuthorizationParameters.CreateAuthorizationType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updateAuthorizationType": {
                    "type": ".squareup.connect.v2.AuthorizationParameters.UpdateAuthorizationType",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CreateAuthorizationType": {
                    "values": {
                      "DO_NOT_USE_CREATE_AUTH_TYPE": 0,
                      "PRE_AUTH": 1,
                      "SALE": 2
                    }
                  },
                  "UpdateAuthorizationType": {
                    "values": {
                      "DO_NOT_USE_UPDATE_AUTH_TYPE": 0,
                      "INC_AUTH": 1
                    }
                  }
                }
              },
              "CardSurchargeDetails": {
                "fields": {
                  "cardSurchargeMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "additionalAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TrustedPartnerDetails": {
                "fields": {
                  "type": {
                    "type": ".squareup.connect.v2.TrustedPartnerDetails.Type",
                    "id": 1,
                    "rule": "optional"
                  },
                  "paymentLinkDetails": {
                    "type": ".squareup.connect.v2.PaymentLinkDetails",
                    "id": 2,
                    "rule": "optional"
                  },
                  "externalTransactionId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 4,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Type": {
                    "values": {
                      "NO_TYPE": 0,
                      "PAYMENT_LINK": 1,
                      "THIRD_PARTY_TERMINAL": 2
                    }
                  }
                }
              },
              "PaymentLinkDetails": {
                "fields": {
                  "paymentUrl": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "StoredValuePaymentDetails": {
                "fields": {
                  "transactionId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "remainingBalanceAmountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "thirdPartyCustomerId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AuthenticationResult": {
                "fields": {
                  "chargebackLiableParty": {
                    "type": ".squareup.connect.v2.AuthenticationResult.ChargebackLiableParty",
                    "id": 1,
                    "rule": "optional"
                  },
                  "chargebackLiablePartyReason": {
                    "type": ".squareup.connect.v2.AuthenticationResult.ChargebackLiablePartyReason",
                    "id": 2,
                    "rule": "optional"
                  },
                  "threeDsIssuerChallenged": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "threeDsTransactionStatus": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ChargebackLiableParty": {
                    "values": {
                      "DO_NOT_USE_CHARGEBACK_LIABLE_REASON": 0,
                      "SELLER_LIABILITY": 1,
                      "ISSUER_LIABILITY": 2
                    }
                  },
                  "ChargebackLiablePartyReason": {
                    "values": {
                      "DO_NOT_USE_CHARGEBACK_LIABLE_PARTY_REASON": 0,
                      "SELLER_DEFAULT": 1,
                      "THREE_DS_AUTHENTICATED": 2,
                      "DIGITAL_WALLET_AUTHENTICATED": 3
                    }
                  }
                }
              },
              "ItemizationData": {
                "fields": {
                  "items": {
                    "type": ".squareup.connect.v2.Item",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "totalTaxMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Item": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "quantity": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "totalCostMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "totalTaxMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "BuyerDetails": {
                "fields": {
                  "cashAppCustomer": {
                    "type": ".squareup.connect.v2.CashAppCustomer",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CashAppCustomer": {
                "fields": {
                  "customerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ReadOnlyExcept && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.Payment && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ForeignExchange && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CurrencyExchange && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CardPaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.EmvDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BalancePaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CashPaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ExternalPaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.RecurringPaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.IssuerInstallmentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.IssuerInstallmentDetails?.nested?.IssuerInstallmentType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BankAccountPaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ACHDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.OpenBankingDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.EFTDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DigitalWalletDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CashAppDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.PaypayDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.LightningDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.MultiBrandDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.MultiBrandDetails?.nested?.MultiBrandPaymentMethod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.LocalizedStatus && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.DeviceCredential && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.FelicaDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.FelicaDetails?.nested?.FelicaBrand && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ApplicationDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ApplicationDetails?.nested?.ExternalSquareProduct && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BuyNowPayLaterDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AfterpayDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ClearpayDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SquareAccountDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CardPaymentTimeline && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ProcessingFee && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AppProcessingFee && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.RefundPolicy && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CapabilitiesList && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.HealthcareDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ElectronicMoneyDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.OfflinePaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuthorizationParameters && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuthorizationParameters?.nested?.CreateAuthorizationType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuthorizationParameters?.nested?.UpdateAuthorizationType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CardSurchargeDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.TrustedPartnerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.TrustedPartnerDetails?.nested?.Type && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.PaymentLinkDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.StoredValuePaymentDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuthenticationResult && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuthenticationResult?.nested?.ChargebackLiableParty && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.AuthenticationResult?.nested?.ChargebackLiablePartyReason && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.ItemizationData && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.Item && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.BuyerDetails && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.CashAppCustomer) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A custom option for marking fields that are read-only except for
 * one or more subfields.
 * --
 *
 * SOURCE ReadOnlyExcept @ squareup/pago/external/payments_model.proto at 32:1
 */
export const ReadOnlyExcept = $root.lookupType('squareup.connect.v2.ReadOnlyExcept');
fixType(ReadOnlyExcept);
Builder.createAndAttachToType(ReadOnlyExcept);
/**
 * --
 * @desc Represents a payment processed by the Square API.
 * --
 *
 * SOURCE Payment @ squareup/pago/external/payments_model.proto at 41:1
 */
export const Payment = $root.lookupType('squareup.connect.v2.Payment');
fixType(Payment);
Builder.createAndAttachToType(Payment);
/**
 * --
 * @desc Details about a foreign exchange.
 * --
 *
 * SOURCE ForeignExchange @ squareup/pago/external/payments_model.proto at 619:1
 */
export const ForeignExchange = $root.lookupType('squareup.connect.v2.ForeignExchange');
fixType(ForeignExchange);
Builder.createAndAttachToType(ForeignExchange);
/**
 * --
 * @desc Represents currency exchange information for payments where the buyer's currency
 * differs from the merchant's currency (e.g., bitcoin lightning payments).
 * --
 *
 * SOURCE CurrencyExchange @ squareup/pago/external/payments_model.proto at 647:1
 */
export const CurrencyExchange = $root.lookupType('squareup.connect.v2.CurrencyExchange');
fixType(CurrencyExchange);
Builder.createAndAttachToType(CurrencyExchange);
/**
 * --
 * @desc Reflects the current status of a card payment. Contains only non-confidential information.
 * --
 *
 * SOURCE CardPaymentDetails @ squareup/pago/external/payments_model.proto at 672:1
 */
export const CardPaymentDetails = $root.lookupType('squareup.connect.v2.CardPaymentDetails');
fixType(CardPaymentDetails);
Builder.createAndAttachToType(CardPaymentDetails);
/**
 * --
 * @desc Holds a subset of EmvData that we propagate through v2/payments
 * --
 *
 * SOURCE EmvDetails @ squareup/pago/external/payments_model.proto at 876:1
 */
export const EmvDetails = $root.lookupType('squareup.connect.v2.EmvDetails');
fixType(EmvDetails);
Builder.createAndAttachToType(EmvDetails);
/**
 * --
 * @desc Reflects the current status of a balance payment. Contains only non-confidential information.
 * --
 *
 * SOURCE BalancePaymentDetails @ squareup/pago/external/payments_model.proto at 898:1
 */
export const BalancePaymentDetails = $root.lookupType('squareup.connect.v2.BalancePaymentDetails');
fixType(BalancePaymentDetails);
Builder.createAndAttachToType(BalancePaymentDetails);
/**
 * --
 * @desc Stores details about a cash payment. Contains only non-confidential information. For more information, see
 * [Take Cash Payments](https://developer.squareup.com/docs/payments-api/take-payments/cash-payments).
 * --
 *
 * SOURCE CashPaymentDetails @ squareup/pago/external/payments_model.proto at 918:1
 */
export const CashPaymentDetails = $root.lookupType('squareup.connect.v2.CashPaymentDetails');
fixType(CashPaymentDetails, {
  buyerSuppliedMoney: {
    required: true
  }
});
Builder.createAndAttachToType(CashPaymentDetails);
/**
 * --
 * @desc Stores details about an external payment. Contains only non-confidential information.
 * For more information, see
 * [Take External Payments](https://developer.squareup.com/docs/payments-api/take-payments/external-payments).
 * --
 *
 * SOURCE ExternalPaymentDetails @ squareup/pago/external/payments_model.proto at 948:1
 */
export const ExternalPaymentDetails = $root.lookupType('squareup.connect.v2.ExternalPaymentDetails');
fixType(ExternalPaymentDetails, {
  type: {
    required: true
  },
  source: {
    required: true
  }
});
Builder.createAndAttachToType(ExternalPaymentDetails);
/**
 * --
 * @desc Additional details indicating that this payment is part of a recurring series.
 * --
 *
 * SOURCE RecurringPaymentDetails @ squareup/pago/external/payments_model.proto at 991:1
 */
export const RecurringPaymentDetails = $root.lookupType('squareup.connect.v2.RecurringPaymentDetails');
fixType(RecurringPaymentDetails, {
  seriesPosition: {
    required: true
  }
});
Builder.createAndAttachToType(RecurringPaymentDetails);
/**
 * --
 * @desc Details for payments that the issuer will bill to the cardholder in installments over time, as
 * requested by the cardholder. When applied, settlement still occurs to Square and the merchant
 * in full as a single payment. This option is only available in certain markets (Japan, as of
 * Jan. 2024).
 * --
 *
 * SOURCE IssuerInstallmentDetails @ squareup/pago/external/payments_model.proto at 1015:1
 */
export const IssuerInstallmentDetails = $root.lookupType('squareup.connect.v2.IssuerInstallmentDetails');
fixType(IssuerInstallmentDetails);
Builder.createAndAttachToType(IssuerInstallmentDetails);
/**
 * SOURCE IssuerInstallmentType @ squareup/pago/external/payments_model.proto at 1018:3
 */
IssuerInstallmentDetails.IssuerInstallmentType = $root.lookupEnum('squareup.connect.v2.IssuerInstallmentDetails.IssuerInstallmentType').values;
/**
 * --
 * @desc Additional details about BANK_ACCOUNT type payments.
 * --
 *
 * SOURCE BankAccountPaymentDetails @ squareup/pago/external/payments_model.proto at 1052:1
 */
export const BankAccountPaymentDetails = $root.lookupType('squareup.connect.v2.BankAccountPaymentDetails');
fixType(BankAccountPaymentDetails);
Builder.createAndAttachToType(BankAccountPaymentDetails);
/**
 * --
 * @desc ACH-specific details about `BANK_ACCOUNT` type payments with the `transfer_type` of `ACH`.
 * --
 *
 * SOURCE ACHDetails @ squareup/pago/external/payments_model.proto at 1121:1
 */
export const ACHDetails = $root.lookupType('squareup.connect.v2.ACHDetails');
fixType(ACHDetails);
Builder.createAndAttachToType(ACHDetails);
/**
 * --
 * @desc Open Banking-specific details about `BANK_ACCOUNT` type payments.
 * --
 *
 * SOURCE OpenBankingDetails @ squareup/pago/external/payments_model.proto at 1145:1
 */
export const OpenBankingDetails = $root.lookupType('squareup.connect.v2.OpenBankingDetails');
fixType(OpenBankingDetails);
Builder.createAndAttachToType(OpenBankingDetails);
/**
 * --
 * @desc EFT-specific details about `BANK_ACCOUNT` type payments with the `transfer_type` of `EFT`.
 * --
 *
 * SOURCE EFTDetails @ squareup/pago/external/payments_model.proto at 1169:1
 */
export const EFTDetails = $root.lookupType('squareup.connect.v2.EFTDetails');
fixType(EFTDetails);
Builder.createAndAttachToType(EFTDetails);
/**
 * --
 * @desc Additional details about `WALLET` type payments. Contains only non-confidential information.
 * --
 *
 * SOURCE DigitalWalletDetails @ squareup/pago/external/payments_model.proto at 1201:1
 */
export const DigitalWalletDetails = $root.lookupType('squareup.connect.v2.DigitalWalletDetails');
fixType(DigitalWalletDetails);
Builder.createAndAttachToType(DigitalWalletDetails);
/**
 * --
 * @desc Additional details about `WALLET` type payments with the `brand` of `CASH_APP`.
 * --
 *
 * SOURCE CashAppDetails @ squareup/pago/external/payments_model.proto at 1271:1
 */
export const CashAppDetails = $root.lookupType('squareup.connect.v2.CashAppDetails');
fixType(CashAppDetails);
Builder.createAndAttachToType(CashAppDetails);
/**
 * --
 * @desc Additional details about `WALLET` type payments with the `brand` of `PAYPAY`.
 * --
 *
 * SOURCE PaypayDetails @ squareup/pago/external/payments_model.proto at 1299:1
 */
export const PaypayDetails = $root.lookupType('squareup.connect.v2.PaypayDetails');
fixType(PaypayDetails);
Builder.createAndAttachToType(PaypayDetails);
/**
 * --
 * @desc Additional details about `WALLET` type payments with the `brand` of `LIGHTNING`.
 * --
 *
 * SOURCE LightningDetails @ squareup/pago/external/payments_model.proto at 1315:1
 */
export const LightningDetails = $root.lookupType('squareup.connect.v2.LightningDetails');
fixType(LightningDetails);
Builder.createAndAttachToType(LightningDetails);
/**
 * --
 * @desc Additional details about `WALLET` type payments with the `brand` of `MULTI_BRAND`.
 * --
 *
 * SOURCE MultiBrandDetails @ squareup/pago/external/payments_model.proto at 1338:1
 */
export const MultiBrandDetails = $root.lookupType('squareup.connect.v2.MultiBrandDetails');
fixType(MultiBrandDetails);
Builder.createAndAttachToType(MultiBrandDetails);
/**
 * SOURCE MultiBrandPaymentMethod @ squareup/pago/external/payments_model.proto at 1346:3
 */
MultiBrandDetails.MultiBrandPaymentMethod = $root.lookupEnum('squareup.connect.v2.MultiBrandDetails.MultiBrandPaymentMethod').values;
/**
 * SOURCE LocalizedStatus @ squareup/pago/external/payments_model.proto at 1376:1
 */
export const LocalizedStatus = $root.lookupType('squareup.connect.v2.LocalizedStatus');
fixType(LocalizedStatus);
Builder.createAndAttachToType(LocalizedStatus);
/**
 * --
 * @desc Details about the device that took the payment.
 * --
 *
 * SOURCE DeviceDetails @ squareup/pago/external/payments_model.proto at 1398:1
 */
export const DeviceDetails = $root.lookupType('squareup.connect.v2.DeviceDetails');
fixType(DeviceDetails);
Builder.createAndAttachToType(DeviceDetails);
/**
 * --
 * @desc The device credential of the device that took the payment.
 * --
 *
 * SOURCE DeviceCredential @ squareup/pago/external/payments_model.proto at 1428:1
 */
export const DeviceCredential = $root.lookupType('squareup.connect.v2.DeviceCredential');
fixType(DeviceCredential);
Builder.createAndAttachToType(DeviceCredential);
/**
 * --
 * @desc Details for Felica payments.
 * --
 *
 * SOURCE FelicaDetails @ squareup/pago/external/payments_model.proto at 1447:1
 */
export const FelicaDetails = $root.lookupType('squareup.connect.v2.FelicaDetails');
fixType(FelicaDetails);
Builder.createAndAttachToType(FelicaDetails);
/**
 * --
 * @desc A Felica card's "sub-brand"--the actual brand on the Felica card
 * --
 *
 * SOURCE FelicaBrand @ squareup/pago/external/payments_model.proto at 1465:3
 */
FelicaDetails.FelicaBrand = $root.lookupEnum('squareup.connect.v2.FelicaDetails.FelicaBrand').values;
/**
 * --
 * @desc Details about the application that took the payment.
 * --
 *
 * SOURCE ApplicationDetails @ squareup/pago/external/payments_model.proto at 1484:1
 */
export const ApplicationDetails = $root.lookupType('squareup.connect.v2.ApplicationDetails');
fixType(ApplicationDetails);
Builder.createAndAttachToType(ApplicationDetails);
/**
 * --
 * @desc A list of products to return to external callers.
 * --
 *
 * SOURCE ExternalSquareProduct @ squareup/pago/external/payments_model.proto at 1488:3
 */
ApplicationDetails.ExternalSquareProduct = $root.lookupEnum('squareup.connect.v2.ApplicationDetails.ExternalSquareProduct').values;
/**
 * --
 * @desc Additional details about a Buy Now Pay Later payment type.
 * --
 *
 * SOURCE BuyNowPayLaterDetails @ squareup/pago/external/payments_model.proto at 1524:1
 */
export const BuyNowPayLaterDetails = $root.lookupType('squareup.connect.v2.BuyNowPayLaterDetails');
fixType(BuyNowPayLaterDetails);
Builder.createAndAttachToType(BuyNowPayLaterDetails);
/**
 * --
 * @desc Additional details about Afterpay payments.
 * --
 *
 * SOURCE AfterpayDetails @ squareup/pago/external/payments_model.proto at 1554:1
 */
export const AfterpayDetails = $root.lookupType('squareup.connect.v2.AfterpayDetails');
fixType(AfterpayDetails);
Builder.createAndAttachToType(AfterpayDetails);
/**
 * --
 * @desc Additional details about Clearpay payments.
 * --
 *
 * SOURCE ClearpayDetails @ squareup/pago/external/payments_model.proto at 1568:1
 */
export const ClearpayDetails = $root.lookupType('squareup.connect.v2.ClearpayDetails');
fixType(ClearpayDetails);
Builder.createAndAttachToType(ClearpayDetails);
/**
 * --
 * @desc Additional details about Square Account payments.
 * --
 *
 * SOURCE SquareAccountDetails @ squareup/pago/external/payments_model.proto at 1581:1
 */
export const SquareAccountDetails = $root.lookupType('squareup.connect.v2.SquareAccountDetails');
fixType(SquareAccountDetails);
Builder.createAndAttachToType(SquareAccountDetails);
/**
 * --
 * @desc The timeline for card payments.
 * --
 *
 * SOURCE CardPaymentTimeline @ squareup/pago/external/payments_model.proto at 1596:1
 */
export const CardPaymentTimeline = $root.lookupType('squareup.connect.v2.CardPaymentTimeline');
fixType(CardPaymentTimeline);
Builder.createAndAttachToType(CardPaymentTimeline);
/**
 * --
 * @desc Represents the Square processing fee.
 * --
 *
 * SOURCE ProcessingFee @ squareup/pago/external/payments_model.proto at 1617:1
 */
export const ProcessingFee = $root.lookupType('squareup.connect.v2.ProcessingFee');
fixType(ProcessingFee);
Builder.createAndAttachToType(ProcessingFee);
/**
 * --
 * @desc Represents an application processing fee.
 * --
 *
 * SOURCE AppProcessingFee @ squareup/pago/external/payments_model.proto at 1640:1
 */
export const AppProcessingFee = $root.lookupType('squareup.connect.v2.AppProcessingFee');
fixType(AppProcessingFee);
Builder.createAndAttachToType(AppProcessingFee);
/**
 * --
 * @desc Options for controlling how a payment is refunded by default.
 * --
 *
 * SOURCE RefundPolicy @ squareup/pago/external/payments_model.proto at 1674:1
 */
export const RefundPolicy = $root.lookupType('squareup.connect.v2.RefundPolicy');
fixType(RefundPolicy);
Builder.createAndAttachToType(RefundPolicy);
/**
 * --
 * @desc Represents a list of actions that can be performed.
 * --
 *
 * SOURCE CapabilitiesList @ squareup/pago/external/payments_model.proto at 1693:1
 */
export const CapabilitiesList = $root.lookupType('squareup.connect.v2.CapabilitiesList');
fixType(CapabilitiesList);
Builder.createAndAttachToType(CapabilitiesList);
/**
 * --
 * @desc Healthcare-related payment details.
 * --
 *
 * SOURCE HealthcareDetails @ squareup/pago/external/payments_model.proto at 1705:1
 */
export const HealthcareDetails = $root.lookupType('squareup.connect.v2.HealthcareDetails');
fixType(HealthcareDetails);
Builder.createAndAttachToType(HealthcareDetails);
/**
 * --
 * @desc Details specific to electronic money payments.
 * --
 *
 * SOURCE ElectronicMoneyDetails @ squareup/pago/external/payments_model.proto at 1732:1
 */
export const ElectronicMoneyDetails = $root.lookupType('squareup.connect.v2.ElectronicMoneyDetails');
fixType(ElectronicMoneyDetails);
Builder.createAndAttachToType(ElectronicMoneyDetails);
/**
 * --
 * @desc Details specific to offline payments.
 * --
 *
 * SOURCE OfflinePaymentDetails @ squareup/pago/external/payments_model.proto at 1745:1
 */
export const OfflinePaymentDetails = $root.lookupType('squareup.connect.v2.OfflinePaymentDetails');
fixType(OfflinePaymentDetails);
Builder.createAndAttachToType(OfflinePaymentDetails);
/**
 * --
 * @desc Optional parameters that specify how the payment should be authorized. Determines the
 * authorization flow and processing behavior for the payment.
 * --
 *
 * SOURCE AuthorizationParameters @ squareup/pago/external/payments_model.proto at 1773:1
 */
export const AuthorizationParameters = $root.lookupType('squareup.connect.v2.AuthorizationParameters');
fixType(AuthorizationParameters);
Builder.createAndAttachToType(AuthorizationParameters);
/**
 * SOURCE CreateAuthorizationType @ squareup/pago/external/payments_model.proto at 1776:3
 */
AuthorizationParameters.CreateAuthorizationType = $root.lookupEnum('squareup.connect.v2.AuthorizationParameters.CreateAuthorizationType').values;
/**
 * SOURCE UpdateAuthorizationType @ squareup/pago/external/payments_model.proto at 1788:3
 */
AuthorizationParameters.UpdateAuthorizationType = $root.lookupEnum('squareup.connect.v2.AuthorizationParameters.UpdateAuthorizationType').values;
/**
 * --
 * @desc Details related to an attempt to apply a card surcharge to this payment.  When surcharge
 * eligibility is not known in advance, such as when the card type (debit or credit) is required
 * to make the eligibility determination, proposed_card_surcharge_money and
 * proposed_additional_amount_money will match the values in the request, while card_surcharge_money
 * and additional_amount_money are present only when the payment has a surcharge applied.
 * --
 *
 * SOURCE CardSurchargeDetails @ squareup/pago/external/payments_model.proto at 1816:1
 */
export const CardSurchargeDetails = $root.lookupType('squareup.connect.v2.CardSurchargeDetails');
fixType(CardSurchargeDetails);
Builder.createAndAttachToType(CardSurchargeDetails);
/**
 * --
 * @desc Additional details about Trusted Partner payments.
 * --
 *
 * SOURCE TrustedPartnerDetails @ squareup/pago/external/payments_model.proto at 1847:1
 */
export const TrustedPartnerDetails = $root.lookupType('squareup.connect.v2.TrustedPartnerDetails');
fixType(TrustedPartnerDetails);
Builder.createAndAttachToType(TrustedPartnerDetails);
/**
 * SOURCE Type @ squareup/pago/external/payments_model.proto at 1850:3
 */
TrustedPartnerDetails.Type = $root.lookupEnum('squareup.connect.v2.TrustedPartnerDetails.Type').values;
/**
 * --
 * @desc Additional details about Payment Link payments.
 * --
 *
 * SOURCE PaymentLinkDetails @ squareup/pago/external/payments_model.proto at 1891:1
 */
export const PaymentLinkDetails = $root.lookupType('squareup.connect.v2.PaymentLinkDetails');
fixType(PaymentLinkDetails);
Builder.createAndAttachToType(PaymentLinkDetails);
/**
 * --
 * @desc Additional details about Stored Value payments.
 * --
 *
 * SOURCE StoredValuePaymentDetails @ squareup/pago/external/payments_model.proto at 1903:1
 */
export const StoredValuePaymentDetails = $root.lookupType('squareup.connect.v2.StoredValuePaymentDetails');
fixType(StoredValuePaymentDetails);
Builder.createAndAttachToType(StoredValuePaymentDetails);
/**
 * --
 * @desc The result of the authentication results for a card-not-present payment. See
 * https://developer.squareup.com/docs/sca-overview for more information.
 * --
 *
 * SOURCE AuthenticationResult @ squareup/pago/external/payments_model.proto at 1932:1
 */
export const AuthenticationResult = $root.lookupType('squareup.connect.v2.AuthenticationResult');
fixType(AuthenticationResult);
Builder.createAndAttachToType(AuthenticationResult);
/**
 * SOURCE ChargebackLiableParty @ squareup/pago/external/payments_model.proto at 1934:3
 */
AuthenticationResult.ChargebackLiableParty = $root.lookupEnum('squareup.connect.v2.AuthenticationResult.ChargebackLiableParty').values;
/**
 * SOURCE ChargebackLiablePartyReason @ squareup/pago/external/payments_model.proto at 1948:3
 */
AuthenticationResult.ChargebackLiablePartyReason = $root.lookupEnum('squareup.connect.v2.AuthenticationResult.ChargebackLiablePartyReason').values;
/**
 * --
 * @desc Client provided itemized data for the cart. Currently this is only used in combination with
 * async transaction payments.
 * --
 *
 * SOURCE ItemizationData @ squareup/pago/external/payments_model.proto at 2005:1
 */
export const ItemizationData = $root.lookupType('squareup.connect.v2.ItemizationData');
fixType(ItemizationData);
Builder.createAndAttachToType(ItemizationData);
/**
 * --
 * @desc Information for an item that is present in the cart.
 * --
 *
 * SOURCE Item @ squareup/pago/external/payments_model.proto at 2022:1
 */
export const Item = $root.lookupType('squareup.connect.v2.Item');
fixType(Item);
Builder.createAndAttachToType(Item);
/**
 * --
 * @desc Details about the buyer.
 * --
 *
 * SOURCE BuyerDetails @ squareup/pago/external/payments_model.proto at 2049:1
 */
export const BuyerDetails = $root.lookupType('squareup.connect.v2.BuyerDetails');
fixType(BuyerDetails);
Builder.createAndAttachToType(BuyerDetails);
/**
 * --
 * @desc Details about the Cash App customer.
 * --
 *
 * SOURCE CashAppCustomer @ squareup/pago/external/payments_model.proto at 2061:1
 */
export const CashAppCustomer = $root.lookupType('squareup.connect.v2.CashAppCustomer');
fixType(CashAppCustomer);
Builder.createAndAttachToType(CashAppCustomer);